"use client";

import { cn } from "@/lib/utils";
import React from "react";
import ReactMarkdown from "react-markdown";

export const RenderMarkdown = ({
  children,
  isIconBox = false,
}: {
  children: string;
  isIconBox?: boolean;
}) => {
  return (
    <ReactMarkdown
      components={{
        p: ({ children }) => (
          <p
            className={cn(
              isIconBox
                ? "text-base leading-relaxed"
                : "text-base lg:text-lg lg:leading-relaxed",
            )}
          >
            {children}
          </p>
        ),
        br: () => <br />,
        ul: ({ children }) => (
          <ul className="list-disc pl-5 text-base">{children}</ul>
        ),
        li: ({ children }) => <li className="mb-2">{children}</li>,
        strong: ({ children }) => (
          <strong className="font-bold">{children}</strong>
        ),
        em: ({ children }) => <em className="italic">{children}</em>,
      }}
    >
      {children}
    </ReactMarkdown>
  );
};
